export const flattenItemPages = <T extends { id: string }>(pages: { data: T[] }[] | undefined): T[] => {
    const byId = new Map<string, T>();
    for (const item of (pages ?? []).flatMap((page) => page.data)) {
        if (!byId.has(item.id)) byId.set(item.id, item);
    }
    return [...byId.values()];
};
